import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, body, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center gap-2 px-6 text-center', className)}
    >
      {icon !== undefined && (
        <div className="mb-1 flex size-10 items-center justify-center rounded-lg border border-border-subtle bg-bg-2 text-text-3 [&_svg]:size-5">
          {icon}
        </div>
      )}
      <p className="text-sm font-medium text-text-1">{title}</p>
      {body !== undefined && <p className="max-w-80 text-sm text-text-3">{body}</p>}
      {action !== undefined && <div className="mt-2">{action}</div>}
    </div>
  );
}
